import { handleApiRequest } from 'Utils/handleApiRequest';
import { sendReportST } from 'Utils/serviceTitanSyncAssets';

export const SELECTED_REPORT_LOCATIONS = 'SELECTED_REPORT_LOCATIONS';
export const SELECTED_REPORT_ROOMS = 'SELECTED_REPORT_ROOMS';
export const SELECTED_REPORT_SCOPE_OF_WORK = 'SELECTED_REPORT_SCOPE_OF_WORK';
export const REPORT_CREATING = 'REPORT_CREATING';
export const REPORT_UPDATING = 'REPORT_UPDATING';
export const REPORT_SHARING = 'REPORT_SHARING';
export const REPORT_CREATED = 'REPORT_CREATED';
export const REPORT_UPDATED = 'REPORT_UPDATED';
export const REPORT_DELETED = 'REPORT_DELETED';
export const SELECTED_REPORT = 'SELECTED_REPORT';
export const REPORT_SHARED = 'REPORT_SHARED';
export const PROJECT_REPORTS = 'PROJECT_REPORTS';
export const PROJECT_REPORT = 'PROJECT_REPORT';
export const CLEAR_REPORTS = 'CLEAR_REPORTS';
export const REPORT_ERRORS = 'REPORT_ERRORS';

interface ActionTypes {
  SELECTED_REPORT_LOCATIONS: any[];
  SELECTED_REPORT_ROOMS: any[];
  SELECTED_REPORT_SCOPE_OF_WORK: any[];
  REPORT_CREATING: boolean;
  REPORT_UPDATING: boolean;
  REPORT_SHARING: boolean;
  REPORT_CREATED: boolean;
  REPORT_UPDATED: boolean;
  REPORT_DELETED: boolean;
  SELECTED_REPORT: any;
  REPORT_SHARED: boolean;
  PROJECT_REPORT: any;
  PROJECT_REPORTS: any[];
  REPORT_ERRORS: any[];
  CLEAR_REPORTS: any;
}

interface MessageAction {
  type: keyof ActionTypes;
  payload: any;
}

export type reportActionTypes = MessageAction;

export const setSelectedReportLocations = (payload: number) => (dispatch) => {
  dispatch({
    type: SELECTED_REPORT_LOCATIONS,
    payload,
  });
};

export const setSelectedReportRooms = (payload: number) => (dispatch) => {
  dispatch({
    type: SELECTED_REPORT_ROOMS,
    payload,
  });
};

export const setSelectedScopeOfWork = (payload: number) => (dispatch) => {
  dispatch({
    type: SELECTED_REPORT_SCOPE_OF_WORK,
    payload,
  });
};

export const setReportCreated = (payload: boolean) => (dispatch) => {
  dispatch({
    type: REPORT_CREATED,
    payload,
  });
};

export const setReportUpdated = (payload: boolean) => (dispatch) => {
  dispatch({
    type: REPORT_UPDATED,
    payload,
  });
};

export const setReportDeleted = (payload: boolean) => (dispatch) => {
  dispatch({
    type: REPORT_DELETED,
    payload,
  });
};

export const setSelectedReportEdit = (payload: any) => (dispatch) => {
  dispatch({
    type: SELECTED_REPORT,
    payload,
  });
};

export const setReportShared = (payload: boolean) => (dispatch) => {
  dispatch({
    type: REPORT_SHARED,
    payload,
  });
};

export const clearReportsList = () => (dispatch) => {
  dispatch({
    type: CLEAR_REPORTS,
  });
};

export const resetCustomReport = () => (dispatch) => {
  dispatch({
    type: PROJECT_REPORT,
    payload: undefined,
  });
};

/*
 * API THUNKS
 * */

/* eslint-disable */

export const createReport =
  (projectId: number, requestData: any, alias: string, user) =>
  async (dispatch: any, _getState = null, utils: any) => {
    const response = await handleApiRequest(
      dispatch,
      utils.Api.post(`projects/${projectId}/reports`, requestData),
      REPORT_ERRORS,
      REPORT_CREATING
    );

    sendReportST(projectId, response, alias, user);

    if (response?.data) {
      dispatch(setReportCreated(true));
    }
  };

export const updateReport =
  (reportId: number, requestData: any) =>
  async (dispatch: any, _getState = null, utils: any) => {
    const response = await handleApiRequest(
      dispatch,
      utils.Api.put(`reports/${reportId}`, requestData),
      REPORT_ERRORS,
      REPORT_UPDATING
    );

    if (response?.data) {
      dispatch(setReportUpdated(true));
    }
  };

export const listProjectReports =
  (projectId: number, sort: string, page: number, itemsPerPage: number, setFetching?: any) =>
  async (dispatch: any, _getState = null, utils: any) => {
    if (setFetching) {
      setFetching(true);
    }
    const response: any = await handleApiRequest(
      dispatch,
      utils.Api.get(`projects/${projectId}/reports`, {
        params: {
          include: 'creator',
          limit: itemsPerPage,
          sort,
          page,
        },
      })
    );

    if (setFetching) {
      setFetching(false);
    }

    if (response?.data) {
      dispatch({
        type: PROJECT_REPORTS,
        payload: response,
      });
    }
  };

export const showProjectReport =
  (reportId: number) =>
  async (dispatch: any, _getState = null, utils: any) => {
    const response: any = await handleApiRequest(dispatch, utils.Api.get(`reports/${reportId}`, {}));

    if (response?.data) {
      const { data } = response;
      dispatch({
        type: PROJECT_REPORT,
        payload: data,
      });
    }
  };

export const deleteReport =
  (reportId: number) =>
  async (dispatch: any, _getState = null, utils: any) => {
    const response = await handleApiRequest(dispatch, utils.Api.delete(`reports/${reportId}`));

    if (typeof response === 'string') {
      dispatch(setReportDeleted(true));
    }
  };

export const shareReport =
  (reportId: number, requestData: any) =>
  async (dispatch: any, _getState = null, utils: any) => {
    const response = await handleApiRequest(
      dispatch,
      utils.Api.post(`reports/${reportId}/shares`, requestData),
      REPORT_ERRORS,
      REPORT_SHARING
    );

    if (typeof response === 'string') {
      dispatch(setReportShared(true));
    }
  };
